import React, { FC } from 'react';
import {
  QueryClient,
  QueryClientProvider,
  QueryCache,
  MutationCache,
} from 'react-query';
import { ThemeProvider, standard } from '@creditas-ui/react';
import { Toaster } from '@creditas-ui/toast';

import { TrackingProvider } from '../../shared/utilities/tagManager/tagManager.hook';
import { tracking } from '../../shared/utilities/tagManager/tagManager.utils';
import { errorHandler } from '../../shared/utilities/errorHandler';

import { ExternalAutoForm } from '../components/ExternalAutoForm';
import { ExternalAutoFormProvider } from './mfExternalAutoForm.context';
import { ExternalAutoFormPageProps } from './mfExternalAutoForm.types';

const queryCache = new QueryCache({
  onError: errorHandler,
});
const mutationCache = new MutationCache({
  onError: errorHandler,
});
const queryClient = new QueryClient({ queryCache, mutationCache });

export const ExternalAutoFormProviders: FC<{
  children: React.ReactNode;
  goTo: {
    toPersonalInfo: string;
    toHasAnApplication: string;
  };
}> = ({ children, goTo }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <TrackingProvider value={tracking}>
        <ThemeProvider theme={standard}>
          <ExternalAutoFormProvider goTo={goTo}>
            {children}
          </ExternalAutoFormProvider>
        </ThemeProvider>
      </TrackingProvider>
    </QueryClientProvider>
  );
};

const ExternalAutoFormPage: FC<ExternalAutoFormPageProps> = ({ goTo }) => {
  return (
    <ExternalAutoFormProviders goTo={goTo}>
      <ExternalAutoForm />
      <Toaster />
    </ExternalAutoFormProviders>
  );
};

export default ExternalAutoFormPage;
